module.exports = __webpack_public_path__ + "static/img_pledge_effect_02@2x-a1e56eb19148668ae55d060d2f0f4e08.png";